import React from "react";
import cx from "classnames";
import { ThemeProvider } from "@material-ui/core/styles";
import { Modal, Fade } from "@material-ui/core";
import { Backdrop } from "src/components/backdrop";
import ScrollLock from "react-scrolllock";
import { BlockContent } from "src/components/block-content";

import { theme } from "src/utils/createMuiTheme";

import { ReactComponent as X } from "src/images/svg/X.svg";

import * as styles from "./info-modal.module.css";

interface ProjectInfoModalProps {
	open: boolean;
	toggle: () => void;
	data: {
		client?: string;
		whatWeDidTags?: {
			tags: any[];
		};
		detailsCopy: any[];
	};
}

export const ProjectInfoModal = ({
	open,
	toggle,
	data,
}: ProjectInfoModalProps) => {
	const { client, whatWeDidTags, detailsCopy } = data;
	return (
		<ThemeProvider theme={theme}>
			<Modal
				open={open}
				onClose={toggle}
				closeAfterTransition={true}
				BackdropComponent={Backdrop}
				BackdropProps={{
					active: open,
					toggle: toggle,
				}}
				style={{ zIndex: 10000 }}
			>
				<Fade
					in={open}
					timeout={{
						enter: 600,
						exit: 300,
					}}
				>
					<div className={cx(styles.drawer)} role="presentation">
						<div className={styles.header}>
							<span className="label c-cream">Info</span>
							<button
								className={cx("reset", styles.closeButton)}
								onClick={toggle}
							>
								<span className="label">Close</span>
								<X className="ml05" />
							</button>
						</div>
						<ScrollLock>
							<div className={cx("c-cream", styles.drawerContent)}>
								<div className={styles.row}>
									<div className={styles.client}>
										<span className={cx("label")}>Client</span>
										<h2 className={cx("title c-highlighter")}>{client}</h2>
									</div>
									<div className={styles.copy}>
										{whatWeDidTags?.tags && (
											<div>
												<span className={cx("label")}>What We Did</span>
												<p className={cx("title c-highlighter my05")}>
													{whatWeDidTags.tags
														.map((tag) => tag.title)
														.join(", ")}
												</p>
											</div>
										)}
										<BlockContent
											className={styles.detailsCopy}
											blocks={detailsCopy}
										/>
									</div>
								</div>
							</div>
						</ScrollLock>
					</div>
				</Fade>
			</Modal>
		</ThemeProvider>
	);
};
